(() => {

  const GiftshipEmojiFilter = {

    init() {
      document.addEventListener('giftship.loaded', this.applyEmojiFilter.bind(this));
    },

    applyEmojiFilter() {

      setTimeout(() => {

        // Covers dingbats, private-use, surrogate-pair (most emoji), and
        // misc symbol ranges. Built from code points instead of \u escapes.
        // Won't catch flags/ZWJ/skin-tone sequences or post-2020 blocks.
        const emojiRanges = [
          [0x2700, 0x27BF],
          [0xE000, 0xF8FF],
          [0xD800, 0xDFFF],
          [0x2011, 0x26FF],
        ];
        const emojiPattern = emojiRanges
          .map(([start, end]) => String.fromCharCode(start) + '-' + String.fromCharCode(end))
          .join('');
        const emojiRegex = new RegExp('[' + emojiPattern + ']', 'g');

        // GiftShip stamps gs__cart-element on every field it renders - To/From/
        // Message plus any custom option inputs or textareas a merchant adds -
        // so bind all of them, not just fields inside .gsMessageContainer.
        const bindField = (field) => {

          if (field.dataset.gsEmojiBound) return;
          field.dataset.gsEmojiBound = 'true';

          let warningLabel = null;

          const removeEmojis = () => {

            const original = field.value;
            const cleaned = original.replace(emojiRegex, '');
            if (original === cleaned) return;

            field.value = cleaned;

            if (!warningLabel) {
              warningLabel = document.createElement('div');
              warningLabel.style.color = 'red';
              warningLabel.style.marginTop = '10px';
              warningLabel.style.fontSize = '0.9em';
              warningLabel.textContent = 'Emoji not supported!';
              field.insertAdjacentElement('afterend', warningLabel);
            }

            clearTimeout(warningLabel.gsHideTimer);
            warningLabel.gsHideTimer = setTimeout(() => {
              warningLabel.remove();
              warningLabel = null;
            }, 3000);
          };

          field.addEventListener('keyup', removeEmojis);
          field.addEventListener('change', removeEmojis);
        };

        const bindAll = () => document
          .querySelectorAll('input.gs__cart-element, textarea.gs__cart-element')
          .forEach(bindField);

        bindAll();

        // GiftShip can add or repaint fields after initial load; re-scan on DOM changes.
        new MutationObserver(bindAll).observe(document.body, { childList: true, subtree: true });

      }, 300);
    }
  };

  GiftshipEmojiFilter.init();

})();
